{
    "SignInWith_Title": "Iniciar sessão com",
    "NAME": "SignInWith",
    "SignInWith_OtherOptions": "Entrar usando outras opções"
}